import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch } from "react-redux";
import {
  ThemeProvider as MuiThemeProvider,
  StylesProvider,
} from "@material-ui/core/styles";
import { ThemeProvider } from "styled-components";
import { theme as voltTheme } from "@volt_developers/react-ui-components";

import maTheme from "./theme";
import MainSwitch from "./routes/switches/MainSwitch";
import { init } from "./store/appSlice";

import { AbilityContext } from "./context/Ability.context";
import { useDefineAbility } from "./hooks/useDefineAbility";

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(init());
  });

  const ability = useDefineAbility();

  return (
    <React.Fragment>
      <Helmet titleTemplate="%s - Volt Fuzebox" defaultTitle="Volt Fuzebox" />
      <AbilityContext.Provider value={ability}>
        <StylesProvider injectFirst>
          <MuiThemeProvider theme={voltTheme}>
            <ThemeProvider theme={maTheme}>
              <MainSwitch />
            </ThemeProvider>
          </MuiThemeProvider>
        </StylesProvider>
      </AbilityContext.Provider>
    </React.Fragment>
  );
}
